export const rmaBadgeVariant = (state: string): 'default' | 'info' | 'success' | 'error' => {
  switch (state) {
    case 'pending':
      return 'info'
    case 'processed':
      return 'success'
    case 'canceled':
      return 'error'
    case 'draft':
    default:
      return 'default'
  }
}
